import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData, occasionOptions } from "../types";

interface OccasionStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const OccasionStep = ({ formData, onChange }: OccasionStepProps) => {
  return (
    <motion.div
      key="occasion"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Calendar className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          What's the Occasion?
        </h2>
        <p className="text-muted-foreground">
          Select the type of event or moment this song is for.
        </p>
      </div>

      <div className="space-y-4">
        <Label>Select one *</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {occasionOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange("occasion", option.value)}
              className={`p-4 rounded-xl border-2 transition-all text-center ${
                formData.occasion === option.value
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/50"
              }`}
            >
              <span className="text-2xl block mb-1">{option.icon}</span>
              <span className="text-sm font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>

      {formData.occasion === "other" && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="space-y-2"
        >
          <Label htmlFor="occasionOther">Please describe the occasion *</Label>
          <Input
            id="occasionOther"
            placeholder="Example: vow renewal, recovery milestone, family reunion"
            value={formData.occasionOther}
            onChange={(e) => onChange("occasionOther", e.target.value)}
          />
        </motion.div>
      )}
    </motion.div>
  );
};

export default OccasionStep;
